import { Toolbar, ToolbarTitle } from '@/components/toolbar';
import { Feedback } from '@/widgets/feedback';
import { useSummaryContext } from './hooks/use-summary-context';
import { SummaryToolbarProps as BaseSummaryToolbarProps } from './types';

type SummaryToolbarProps = React.ComponentProps<'div'> &
  BaseSummaryToolbarProps;

export function SummaryToolbar({ title, ...others }: SummaryToolbarProps) {
  const { data } = useSummaryContext();

  return (
    <Toolbar {...others}>
      {title && <ToolbarTitle>{title}</ToolbarTitle>}
      {data && (
        <Feedback
          className="MemoSummaryToolbar-item"
          data-control="feedback"
          key="feedback"
          object={`resource:${data.id}`}
        />
      )}
    </Toolbar>
  );
}
